import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";
import { motion } from "framer-motion";
import { ReactComponent as Logo } from "assets/images/logo.svg";

import { ThemeProvider } from "@mui/material/styles";
import { useMaterialUIController } from "context";
import theme from "assets/theme-dashboard";
import themeDark from "assets/theme-dark";
import introAudio from "./intro.mp3";

export default function Intro() {
  const navigate = useNavigate();
  const { isSignedIn, isLoaded, user } = useUser();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [titleMsg, setTitleMsg] = useState("Redirect to login...");


  const [redirectReady, setRedirectReady] = useState(false);
  const audioRef = useRef(null);

  // ­ƒºá Sound Autoplay Hack
  useEffect(() => {
    if (audioRef.current) {
      const audio = audioRef.current;
      audio.muted = true;
      audio.play()
        .then(() => {
          // Unmute + set volume
          setTimeout(() => {
            audio.muted = false;
            audio.volume = 0.5;
          }, 200); // kleiner Delay
        })
        .catch(err => {
          console.warn("Autoplay hack failed:", err);
        });
    }
  }, []);

  // ÔÅ¦ Weiterleitung nach 4 Sekunden
  useEffect(() => {
    const timer = setTimeout(() => setRedirectReady(true), 3500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!redirectReady || !isLoaded) return;

    navigate(isSignedIn ? "/dashboard" : "/login");
  }, [redirectReady, isLoaded, isSignedIn, navigate]);


  // Show localized "Willkommen zurueck" message
  useEffect(() => {
    if (isSignedIn) {
      setTitleMsg("Willkommen zur\u00fcck, " + user.firstName + "!");
    } else {
      setTitleMsg("Wir leiten dich weiter...");
    }
  }, [isSignedIn]);

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <div
        style={{
          height: "100vh",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <audio ref={audioRef} src={introAudio} preload="auto" />

        <motion.div
          style={{ position: "relative", width: 200 }}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <div style={{ position: "relative", overflow: "hidden" }}>
            <Logo
              style={{
                width: "100%",
                height: "auto",
                zIndex: 2,
                display: "block",
              }}
            />

            {/* Ô£¿ Glanz-Effekt ÔÇô korrekt von links unten nach rechts oben */}
            <motion.div
              initial={{ x: "-200%" }}
              animate={{ x: "200%" }}
              transition={{ duration: 2.5, delay: 0.6 }}
              style={{
                position: "absolute",
                top: "-150%",
                left: "-150%",
                width: "400%",
                height: "400%",
                background:
                  "linear-gradient(45deg, transparent 40%, rgba(255,255,255,0.4) 50%, transparent 60%)",
                pointerEvents: "none",
                zIndex: 3,
                filter: "blur(3px)",
              }}
            />
          </div>
        </motion.div>

        {/* ­ƒôØ Start-Text */}
        <motion.div
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 1 }}
          style={{
            marginTop: 0,
            fontSize: 32,
            color: "#555",
            fontFamily: "sans-serif",
          }}
        >
          ElecTrack
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.0, duration: 1 }}
          style={{
            marginTop: 10,
            fontSize: 18,
            color: "#555",
            fontFamily: "sans-serif",
          }}
        >
          {titleMsg}
        </motion.div>
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 1 }}
            style={{
              position: "absolute",
              bottom: 20,
              width: "100%",
              textAlign: "center",
              fontSize: 14,
              color: "#888",
              fontFamily: "sans-serif",
            }}
        >           
            Powered by <strong style={{ color: "#444" }}>Dietrich Development</strong>
        </motion.div>

      </div>
    </ThemeProvider>
  );
}









